import { fetchWithDefaults } from "../config/fetchDefault";

let zendeskInitialized = false;

const _createScript = (src) => {
	return new Promise((resolve, reject) => {
		const script = document.createElement('script')
		script.src = src
		script.async = true
		script.id = 'ze-snippet'
		script.onload = resolve
		script.onerror = reject
		document.head.appendChild(script)
	})
}

const _queue = []

const _fakezE = (...args) => {
    _queue.push(args)
}

const initZendesk = async (agentInfo, setConversationFields = true) => {
    const {agentCode, organization, firstName, lastName, email} = agentInfo
    // console.log('attempting initalize zendesk',{args: {agentCode, organization, firstName, lastName, email, setConversationFields}})

    try {
        if (document.getElementById("ze-snippet") || zendeskInitialized) return;

        // console.log('initalizing zendesk')

        zendeskInitialized = true;
        await _createScript(`https://static.zdassets.com/ekr/snippet.js?key=${process.env.REACT_APP_ZENDESK_API_KEY}`)

        if(setConversationFields){
            window.zE("messenger:set", "conversationFields", [
                { id: 34180654131355, value: agentCode },
                { id: 34662830922395, value: `${firstName} ${lastName}` },
                { id: 34662826684315, value: email },
                { id: 37486372350107, value: organization || "Unknown" },
                { id: 37486365418011, value: "Web" }
            ])
        }

        // handle any calls. to zE
        // that were made before
        // the widget was availble
        if (_queue.length > 0) {
            while(_queue.length > 0){
                const args = _queue.shift()
                window.zE(...args)
            }
        }

    } catch (error) {
        console.error("Error initializing Zendesk widget:", error);
    }
}

const getZe = () => {
    return !window.zE ? _fakezE : window.zE
}

const resetZendesk = (cb) => {
    const zE = getZe()
    zE("messenger", "resetWidget", cb())
}

const loginUser = (agentInfo = null, setConversationFields = false) => {
    const zE = getZe()
    const {agentId, agentCode, organization, firstName, lastName, email} = agentInfo

    zE("messenger", "loginUser",
        async (callback) => { // jwtCallback
            const res = await fetchWithDefaults(`/agents/intercomData?agent=${agentId}`);
            const { zendesk_token } = await res.json(); // Add tenantId to your API response if missing

            callback(zendesk_token)
        },
        (error)=>{ // loginCallback
            if (error) {
                // Example error handling
                const { type, reason, message } = error
                console.log(error, type, reason, message)
            }

            if(setConversationFields){
                zE("messenger:set", "conversationFields", [
                    { id: 34180654131355, value: agentCode },
                    { id: 34662830922395, value: `${firstName} ${lastName}` },
                    { id: 34662826684315, value: email },
                    { id: 37486372350107, value: organization || "Unknown" },
                    { id: 37486365418011, value: "Web" }
                ])
            }
        })
}

const logoutUser = () => {
    const zE = getZe()
    zE('messenger', 'logoutUser')
}
export { initZendesk, getZe, resetZendesk, loginUser, logoutUser };
